import { useState } from 'react';
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    Button,
    Alert,
    Divider
} from '@mui/material';
import tooltips from '../../../../../../store/tooltips';
import { useDispatch, useSelector } from 'react-redux';
import BucketList from './buckets/BucketList';
import { getBuckets, postBucket } from '../../../../../../actions/rof-burns/rof-actions';
import RofTooltip from '../../../shared-components/RofTooltip';

export default function Buckets() {

    const dispatch = useDispatch();
    const { selectedProject } = useSelector(state => state.postFormData);
    let { id } = selectedProject || {} //measureType
    const projectKey = id
    const [formErrors, setFormErrors] = useState([])
    const [bucketDetails, setBucketDetails] = useState({
        name: null,
        bucketVolume: null,
        unit: null,
    })

    const setData = e => {
        const { name, value } = e.target;
        setBucketDetails(prevState => ({
            ...prevState,
            [name]: value,
        }));

    }

    const onSubmit = () => {
        // Create a shallow copy of kilnDetails to avoid direct mutation
        const updatedBucketDetails = { ...bucketDetails };

        for (let key in updatedBucketDetails) {
            if (updatedBucketDetails[key] === null) {
                setFormErrors([...formErrors, 'Please complete all form fields when submitting a new Bucket'])
                return
            }
        }

        // Dispatch the action with the updatedKilnDetails
        dispatch(postBucket(updatedBucketDetails, projectKey))
            .then(() => {
                dispatch(getBuckets(projectKey)).then(() => {
                    handleReset();
                })
            })
    }

    const handleReset = () => {
        let resetState = {
            name: null,
            bucketVolume: null,
            unit: null,
        }
        setBucketDetails({ ...resetState });
        setFormErrors([]);
    };

    const units = [
        {
            id: 0,
            name: 'Gallon',
        },
        {
            id: 5,
            name: 'Liter',
        },
    ];

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant='h4'>
                    Buckets
                </Typography>
                <RofTooltip tooltipText={tooltips.logKilnQ1} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant='h6'>
                    Bucket identifier
                </Typography>
                <TextField
                    name='name'
                    value={bucketDetails.name || ''}
                    label='Bucket name'
                    onChange={setData}
                    fullWidth
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant='h6'>
                    What is the unit of the volume measurement?
                </Typography>
                <FormControl
                    fullWidth
                >
                    <InputLabel>
                        Unit
                    </InputLabel>
                    <Select name='unit' value={bucketDetails.unit || ''} onChange={setData}>
                        {units.map(unit => (
                            <MenuItem key={unit.id} value={unit.name}>
                                {unit.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant='h6'>
                    What is the volume of this bucket filled to the top? (Please use a measuring cup to measure the exact volume of this bucket)
                </Typography>
                <TextField
                    name='bucketVolume'
                    value={bucketDetails.bucketVolume || ''}
                    label='Please input volume of bucket here (1 decimal place)'
                    onChange={setData}
                    fullWidth
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {formErrors.length > 0 &&
                    <Alert sx={{ width: 'fit-content' }} severity='error'>
                        Please complete all form fields when submitting a new Bucket
                    </Alert>
                }
                <Button
                    variant='contained'
                    onClick={onSubmit}
                    sx={{ width: 'fit-content' }}
                >
                    Submit
                </Button>
            </Box>
            <Divider />
            <BucketList projectKey={projectKey} />
        </Box>
    );
}
